/**
 * LandingFooter — Footer der öffentlichen Landingpage (W4.2)
 *
 * Links: Impressum (/imprint), Datenschutz (/privacy) — öffentliche,
 * unauthentifizierte Routen (F-PUBLIC-LEGAL-1). Kein GitHub-Link (suite#31) —
 * hier sollen künftig Store-Links (iOS/Android) hin, sobald die Mobile-App
 * live ist.
 * Rechts: Copyright-Zeile
 */
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

const year = new Date().getFullYear()

export function LandingFooter() {
  const { t } = useTranslation('landing')

  return (
    <footer className="landing-footer" data-testid="landing-footer">
      <div className="landing-footer__inner">
        <div className="landing-footer__links">
          <Link to="/imprint" className="landing-footer__link">{t('footer.imprint')}</Link>
          <Link to="/privacy" className="landing-footer__link">{t('footer.privacy')}</Link>
        </div>
        <div className="landing-footer__copy">
          {t('footer.copyright', { year })}
        </div>
      </div>
    </footer>
  )
}
